import { BGM } from "./BGM.js";
import { DustAnimation } from "./DustAnimation.js";
import { DynamicTextManager } from "./DynamicTextManager.js";
import { flagManager } from "./FlagManager.js";
import { GameManager } from "./GameManager.js";
import { KeyboardManager } from "./KeyboardManager.js";
import { pageManager } from "./PageManager.js";
import { Sound } from "./Sound.js";
import { Stage } from "./Stage.js";
import { Stage0 } from "./Stage0.js";
import { Stage1 } from "./Stage1.js";
import { Stage2 } from "./Stage2.js";
import { Stage3 } from "./Stage3.js";
import { Stage4 } from "./Stage4.js";
import { Stage5 } from "./Stage5.js";
import { requestTalk, talkPanel } from "./TalkManager.js";
import { Speech, TalkPanel } from "./TalkPanel.js";
import { qsAll, qsAddEvent, qs, sleep } from "./Utils.js";
import { WaitableDynamicTextManager } from "./WaitableDynamicTextManager.js";

//不正なページ遷移の防止
document.addEventListener("keydown", (e) => {
    if (e.code == "Tab" || e.code == "Space" || e.code == "Enter") {
        e.preventDefault();
    }
});

qsAll("button").forEach((button) => {
    button.tabIndex = -1;
});

//ページ開始処理
document.addEventListener("DOMContentLoaded", async () => {
    pageManager.init();
    BGM.init();
    Sound.init();
    se = [new Sound({ src: "assets/sounds/決定ボタンを押す32.mp3" }), new Sound({ src: "assets/sounds/カーソル移動9.mp3" }), new Sound({ src: "assets/sounds/正解のときの音.mp3" })];
    // sleep(1000);
    // startDebugMode(5);
    // gameManager.goal();
    // BGM.setVolume(0);
});

//.autoDynamicTextに対してそれを含むが開かれるたびに文字のアニメーションを行う
qsAll(".page").forEach((page) => {
    let DTMs: DynamicTextManager[] = [];
    const keyboardManager: KeyboardManager = new KeyboardManager();
    pageManager.addEvent(["pageOpened-" + page.id], () => {
        qsAll("#" + page.id + " .autoDynamicText").forEach((element) => {
            DTMs = [];
            const html = element.dataset.originalHtml || element.innerHTML;
            element.dataset.originalHtml = html;
            element.innerHTML = "";
            const elementDTM = new DynamicTextManager(element, html);

            elementDTM.start();
            keyboardManager.start();
            DTMs.push(elementDTM);
        });
    });

    if (page.id == "settings") {
        qsAddEvent("#wordSpeed", "input", (element) => {
            DTMs[0].reset();
            const value: number = parseInt((element as HTMLInputElement).value);
            DynamicTextManager.masterSetting.writeFrequency = 110 - value * 10;
            WaitableDynamicTextManager.masterSetting.writeFrequency = 110 - value * 10;
            Speech.masterSetting.writeFrequency = 110 - value * 10;
            DTMs[0].s$writeFrequency = DynamicTextManager.masterSetting.writeFrequency;
            DTMs[0].start();
        });
    } else {
        page.addEventListener("click", () => {
            DTMs.forEach((elementDTM) => {
                elementDTM.finish();
            });
        });
    }
});

//ユーザーのクリックによる開始
qsAddEvent("#pageStart", "click", () => {
    pageManager.setPage("title");
    se[0].play();
});

export let gameManager: GameManager;
let stageNumber = -1;

//現在のステージ番号を記録する
qsAll("[data-stage]").forEach((element) => {
    element.addEventListener("click", () => {
        stageNumber = parseInt(element.dataset.stage || "-1");
    });
});

//未クリアステージに行けないようにする
pageManager.addEvent(["pageChanged-stageSelect"], () => {
    if (!flagManager.has("stage0-cleared")) {
        qs('[data-stage="1"]').style.display = "none";
    } else {
        qs('[data-stage="1"]').style.display = "block";
    }
    if (!flagManager.has("stage1-cleared")) {
        qs('[data-stage="2"]').style.display = "none";
    } else {
        qs('[data-stage="2"]').style.display = "block";
    }
    if (!flagManager.has("stage2-cleared")) {
        qs("#stageOptions .options:nth-child(2)").style.display = "none";
        qs('[data-stage="3"]').style.display = "none";
    } else {
        qs("#stageOptions .options:nth-child(2)").style.display = "flex";
        qs('[data-stage="3"]').style.display = "block";
    }
    if (!flagManager.has("stage3-cleared")) {
        qs('[data-stage="4"]').style.display = "none";
    } else {
        qs('[data-stage="4"]').style.display = "block";
    }
    if (!flagManager.has("stage4-cleared")) {
        qs('[data-stage="5"]').style.display = "none";
    } else {
        qs('[data-stage="5"]').style.display = "block";
    }
});
//タイトル画面の隠し
pageManager.addEvent(["pageChanged-title"], () => {
    if (!flagManager.has("clear")) {
        qs("#bonusButton").style.display = "none";
    } else {
        qs("#bonusButton").style.display = "block";
    }
    if (!flagManager.has("yakisoba")) {
        qs("#yakisobaButton").style.display = "none";
    } else {
        qs("#yakisobaButton").style.display = "block";
    }
});

//ステージ0
qsAddEvent('[data-stage="0"]', "click", async () => {
    flagManager.remove("stage0-goalFailed");
    console.log(talkPanel.g$writeFrequency);

    pageManager.setPage("dark");
    requestTalk([
        new Speech({
            content: "…………。",
        }),
        new Speech({
            content: "ここに閉じ込められてから、どのくらい経っただろうか。",
        }),
        new Speech({
            content: "ここには何もない。",
        }),
        new Speech({
            content: 'いや、考えている"自分"は存在している。<br />しかし、自分が何であるかは分からない。',
        }),
        new Speech({
            content: "ただ一つ覚えているのは言葉のみである。",
        }),
        new Speech({
            content: "――聞こえる？　ねえ。聞こえる？",
            speakerName: "？？？",
        }),
        new Speech({
            content: '謎の声が"聞こえた"。それと同時に、一気に情報があふれ出す――。',
        }),
    ]).then(() => {
        console.log(talkPanel.g$writeFrequency);
        pageManager.backPages(1);
        stageStart(new Stage0());
        gameManager.stop();
        requestTalk([
            new Speech({
                content: 'ああ、良かった。"思い出せた"ようね。<br />ここはあなたの心の中。',
                speakerName: "謎の声",
            }),
            new Speech({
                content: 'なんだ、これは。忘れていた<font style="color:#dd0000">感覚</font>が<ruby>堰<rt>せき</rt></ruby>を切ったように溢れ出したようだ。',
            }),
            new Speech({
                content: "それと同時に周りに謎めいた構造物が現れた。いや、知覚できるようになった……？",
            }),
            new Speech({
                content: '大事なのはきっかけよ。あなたがここから出るには、<font style="color:#dd0000">思い出さなければならない</font>。',
                speakerName: "謎の声",
            }),
            new Speech({
                content: "思い出す？",
            }),
            new Speech({
                content: 'そう。ここには<font style="color:#00dd00">記憶の穴</font>がある。<br />それを修復すればあなたは出口に近づく。',
                speakerName: "謎の声",
            }),
            new Speech({
                content:
                    'とはいえ、無から思い出すことは難しい。どこかに<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>が落ちているはず。',
                speakerName: "謎の声",
            }),
            new Speech({
                content: "それはあなたの記憶の<ruby>残滓<rt>ざんし</rt></ruby>。それを見ればきっと思い出すことにつながるわ。",
                speakerName: "謎の声",
            }),
            new Speech({
                content:
                    'なるほど。つまり、<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探して、思い出してから<font style="color:#00dd00">記憶の穴</font>に向かえということか。',
            }),
            new Speech({
                content: 'あなたは<font style="color:#0000dd">W,A,S,Dキー</font>か<font style="color:#0000dd">矢印キー</font>で動けるはずよ。',
                speakerName: "謎の声",
            }),
            new Speech({
                content: "ここでのんびりしていても仕方ないわよ。",
                speakerName: "謎の声",
            }),
        ]).then(() => {
            gameManager.start();
        });
        gameManager.addEvent(["goal"], () => {
            talkPanel.resetTalk();
            if (flagManager.has("stage0-goalFailed")) {
                requestTalk([
                    new Speech({
                        content: 'さて、<font style="color:#00dd00">記憶の穴</font>まで戻ってきたわね。',
                        speakerName: "謎の声",
                    }),
                    new Speech({
                        content: "今度こそ思い出さねばなるまい。",
                    }),
                ]).then(() => {
                    (qs("#answer") as HTMLInputElement).value = "";
                    qs("#questionLabel").innerText = "自分は何者か？";
                    qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                    pageManager.setPage("question");
                });
            } else {
                requestTalk([
                    new Speech({
                        content: 'これが<font style="color:#00dd00">記憶の穴</font>ね。',
                        speakerName: "謎の声",
                    }),
                    new Speech({
                        content: "なにをすればいいんだ？",
                    }),
                    new Speech({
                        content: "自身の忘れた事実――聞かれたことについて答えればいいのよ。",
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    (qs("#answer") as HTMLInputElement).value = "";
                    qs("#questionLabel").innerText = "自分は何者か？";
                    qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                    pageManager.setPage("question");
                });
            }
        });
    });
});

//ステージ1
qsAddEvent('[data-stage="1"]', "click", async () => {
    flagManager.remove("stage1-goalFailed");

    stageStart(new Stage1());
    requestTalk([
        new Speech({
            content: "ここは……。さっきまでいた場所とは違うようだが。",
        }),
        new Speech({
            content: 'あなたが"思い出した"ことにより心の一つ外側に来れたようね。',
            speakerName: "謎の声",
        }),
        new Speech({
            content: "現状は何か変わっているのか？",
        }),
        new Speech({
            content: 'ええ。ここの<font style="color:#00dd00">記憶の穴</font>を修復すればまたあなたは脱出に近づく。',
            speakerName: "謎の声",
        }),
        new Speech({
            content: 'ということは、また<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>探しか。',
        }),
        new Speech({
            content: "とはいえ、ここはさっきより広そうだ。",
        }),
    ]).then(() => {
        gameManager.start();
    });
    gameManager.addEvent(["goal"], () => {
        talkPanel.resetTalk();
        if (flagManager.has("stage1-goalFailed")) {
            requestTalk([
                new Speech({
                    content: 'さて、<font style="color:#00dd00">記憶の穴</font>まで戻ってきたが……。',
                }),
                new Speech({
                    content: "今度はうまく思い出せるかしら。",
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の好きな食べ物は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        } else {
            requestTalk([
                new Speech({
                    content: 'やっと<font style="color:#00dd00">記憶の穴</font>についたわね。',
                    speakerName: "謎の声",
                }),
                new Speech({
                    content: "通ることができる壁を探すのに苦労した。",
                }),
                new Speech({
                    content:
                        'やはりここは不安定なようね。さて、<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を手掛かりに思い出しましょう。',
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の好きな食べ物は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        }
    });
});

//ステージ2
qsAddEvent('[data-stage="2"]', "click", async () => {
    flagManager.remove("stage2-goalFailed");

    stageStart(new Stage2());
    requestTalk([
        new Speech({
            content: "さて、さらに外側に来たようね。",
            speakerName: "謎の声",
        }),
        new Speech({
            content: "からあげ好き人間は次は何を思い出せば良いのだろうか。",
        }),
        new Speech({
            content: "さあ、何をしていたか、とか……。",
            speakerName: "謎の声",
        }),
    ]).then(() => {
        gameManager.start();
    });
    gameManager.addEvent(["goal"], () => {
        talkPanel.resetTalk();
        if (flagManager.has("stage2-goalFailed")) {
            requestTalk([
                new Speech({
                    content: 'ようやく<font style="color:#00dd00">記憶の穴</font>まで戻ってくることができた。',
                }),
                new Speech({
                    content: "もう一度思い出してみましょう。",
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の趣味は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        } else {
            requestTalk([
                new Speech({
                    content: '<font style="color:#00dd00">記憶の穴</font>がちゃんとあったわね。',
                    speakerName: "謎の声",
                }),
                new Speech({
                    content: "まさかそこが押せる壁だったとは。",
                }),
                new Speech({
                    content: "だんだん難しくなっている気がするわね。さて、思い出しましょう。",
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の趣味は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        }
    });
});

//ステージ3
qsAddEvent('[data-stage="3"]', "click", async () => {
    flagManager.remove("stage3-goalFailed");

    stageStart(new Stage3());
    requestTalk([
        new Speech({
            content: '一体何回<font style="color:#00dd00">記憶の穴</font>を修復すればいいんだ。',
        }),
        new Speech({
            content: "とはいえ、かなり進んできているわよ。",
            speakerName: "謎の声",
        }),
        new Speech({
            content: "脱出した先に何があるのか。",
        }),
        new Speech({
            content: "それはあなたが知っていたはず。",
            speakerName: "謎の声",
        }),
    ]).then(() => {
        gameManager.start();
    });
    gameManager.addEvent(["goal"], () => {
        talkPanel.resetTalk();
        if (flagManager.has("stage3-goalFailed")) {
            requestTalk([
                new Speech({
                    content: '<font style="color:#00dd00">記憶の穴</font>がいつもより遠く感じた。',
                }),
                new Speech({
                    content: "実際に遠いからでは。今度こそ思い出したいわね。",
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の仕事は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        } else {
            requestTalk([
                new Speech({
                    content: '<font style="color:#00dd00">記憶の穴</font>はどうしてこんな奥にあるんだ？',
                }),
                new Speech({
                    content: "それだけあなたが忘れているということ。",
                    speakerName: "謎の声",
                }),
                new Speech({
                    content: "なんで忘れているんだろうか……。",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の仕事は何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        }
    });
});

//ステージ4
qsAddEvent('[data-stage="4"]', "click", async () => {
    flagManager.remove("stage4-goalFailed");

    stageStart(new Stage4());
    requestTalk([
        new Speech({
            content: "かなり慣れたからサクッと行きたいところだ。",
        }),
        new Speech({
            content: "思い出すことに慣れるって、奇妙な響き。",
            speakerName: "謎の声",
        }),
        new Speech({
            content: "でもまだ、大切なことを忘れている気がする。",
        }),
    ]).then(() => {
        gameManager.start();
    });
    gameManager.addEvent(["goal"], () => {
        talkPanel.resetTalk();
        if (flagManager.has("stage4-goalFailed")) {
            requestTalk([
                new Speech({
                    content: "戻ってはこれたが……。",
                }),
                new Speech({
                    content: "頑張って思い出すしかないわね。",
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の大切なものは何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        } else {
            requestTalk([
                new Speech({
                    content: "なかなか一筋縄ではいかなかったわね。",
                    speakerName: "謎の声",
                }),
                new Speech({
                    content: "さて、今度こそ思い出せるだろうか。",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "自分の大切なものは何か？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        }
    });
});

qsAddEvent('[data-stage="5"]', "click", async () => {
    flagManager.remove("stage5-goalFailed");

    stageStart(new Stage5());
    requestTalk([
        new Speech({
            content: "好きな食べ物、趣味、仕事、家族……。色々思い出してきたが、まだどこか<ruby>靄<rt>もや</rt></ruby>がかっている。",
        }),
        new Speech({
            content: "おそらく、それが最後のピースね。",
            speakerName: "謎の声",
        }),
        new Speech({
            content: "最後でもやることは同じか。",
        }),
    ]).then(() => {
        gameManager.start();
    });
    gameManager.addEvent(["goal"], () => {
        talkPanel.resetTalk();
        if (flagManager.has("stage5-goalFailed")) {
            requestTalk([
                new Speech({
                    content: 'さあ、こんどこそ"思い出しましょう"。',
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "名前は？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        } else {
            requestTalk([
                new Speech({
                    content: "なんとか辿り着くことができた。",
                }),
                new Speech({
                    content: 'さあ、いつものように"思い出しましょう"。',
                    speakerName: "謎の声",
                }),
            ]).then(() => {
                (qs("#answer") as HTMLInputElement).value = "";
                qs("#questionLabel").innerText = "名前は？";
                qs("#questionDescriptionLabel").innerText = "(ひらがなのみ)";
                pageManager.setPage("question");
            });
        }
    });
});

qsAddEvent("#submitButton", "click", () => {
    const value = (qs("#answer") as HTMLInputElement).value.replace(/[^(\u3040-\u309F | \u30fc)]/g, "");
    console.log(value);
    if (value == "") {
        return;
    }
    flagManager.add("answer");
    switch (stageNumber) {
        case 0:
            if (value == "にんげん") {
                se[2].play();
                requestTalk([
                    new Speech({
                        content: "――そうだ。自分は人間だ。なぜ忘れていたのだろう。",
                    }),
                    new Speech({
                        content: 'うまく思い出せたようね。これであなたは"脱出"に一歩近づいたわ。',
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    flagManager.add("stage0-cleared");
                    stageClear();
                });
            } else if (value == "なぞのこえ") {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あれ、なんだ。さっきまでいた場所だ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "例えばそこの壁から見ればあなたも謎の声かもね。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage0-goalFailed");
            } else if (["いきもの", "せいぶつ", "どうぶつ", "せいめい", "いのち"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あれ、なんだ。さっきまでいた場所だ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "さっきの答えはそんなに間違っていない気がする。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage0-goalFailed");
            } else if (["だいく", "おや", "ちちおや", "ちち", "ぱぱ", "おとうさん", "しょうま"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あれ、なんだ。さっきまでいた場所だ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "なにか思い出せそうだったが忘れてしまった。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage0-goalFailed");
            } else if (["ひと", "じんるい"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あれ、なんだ。さっきまでいた場所だ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "とはいえ、意味的にはほとんど同じだった気がする。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage0-goalFailed");
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あれ、なんだ。さっきまでいた場所だ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage0-goalFailed");
            }
            break;
        case 1:
            if (value == "からあげ") {
                se[2].play();
                requestTalk([
                    new Speech({
                        content: "――そうだ。自分はからあげが好きだ。<br />……こんなこと思い出して何になるんだ。",
                    }),
                    new Speech({
                        content: "人間であることさえ覚えていなかったのによく言うわね。",
                        speakerName: "謎の声",
                    }),
                    new Speech({
                        content: "そういえばここでは腹が減らないのか。そもそも代謝はあるのか……？",
                    }),
                    new Speech({
                        content: 'どこまで行ってもここはあなたの心の中。次の<font style="color:#00dd00">記憶の穴</font>を探しましょう。',
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    flagManager.add("stage1-cleared");
                    if (flagManager.has("yakisoba")) {
                        flagManager.remove("answer");
                        pageManager.backPages(3);
                    } else {
                        stageClear();
                    }
                });
            } else if (value == "やきそば") {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "色んな場所を注意深く観察したほうが良いかもね。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "なんだか、焼きそばも好物だった気がするが。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("yakisoba");
                flagManager.add("stage1-goalFailed");
            } else if (["たつたあげ", "なげっと", "あげどり", "ちきんかつ", "とりてん"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "鶏をカラッと揚げたものだった気がする。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            } else if (["おやこどん", "やきとり"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "油がもっと欲しいかもしれない。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            } else if (
                [
                    "あひあこ",
                    "がいやーん",
                    "かびでら",
                    "けじぇぬ",
                    "さむげたん",
                    "じぶれっつ",
                    "しゃわるま",
                    "そとあやむ",
                    "たっかるび",
                    "たっこち",
                    "てぃのーら",
                    "ばすてぃら",
                    "びなこる",
                    "ぽむ",
                    "むさっはん",
                    "やっさ",
                ].includes(value)
            ) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "というか、何、その料理。マイナー過ぎないかしら。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "鶏料理ではあるはずだが。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            } else if (["てんぷら", "とんかつ", "めんちかつ", "かつどん", "かつ", "えびふらい", "ころっけ", "はるまき", "ぽてと"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "揚げ物といえばやっぱりあの肉だな。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            } else if (value == "うめぼし") {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "あら、このゲームの作者ね。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "どうしていきなりメタくなったんだ。",
                        }),
                        new Speech({
                            content: "さすがに間違えてうめぼしと答える人はいないでしょう。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "それもそうか。",
                        }),
                        new Speech({
                            content: "せっかくだからこのゲームの秘密を言っておきましょう。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "このゲームのエンディングは全部で三つあるわ。",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "探してみることね。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "色んな場所を注意深く観察したほうが良いかもね。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage1-goalFailed");
            }
            break;
        case 2:
            if (value == "つり") {
                se[2].play();
                requestTalk([
                    new Speech({
                        content: "――そうだ。自分は釣りが好きだ。<br />そういえば休日によく行っていた。",
                    }),
                    new Speech({
                        content: "釣りってなかなか渋いわね。時間もかかるわ。",
                        speakerName: "謎の声",
                    }),
                    new Speech({
                        content: "そういえば誰かと行っていた気がする。<br />誰だったか……。",
                    }),
                    new Speech({
                        content: "追々思い出していけるはずよ。",
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    flagManager.add("stage2-cleared");
                    stageClear();
                });
            } else if (["やまのぼり", "とざん"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "あんまり山のほうには行かなかった気がする。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage2-goalFailed");
            } else if (["くるーず", "さーふぃん", "すいえい", "およぎ", "かわあそび"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "いつかはやってみたいが、泳げなかった気がする。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage2-goalFailed");
            } else if (value == "てろ") {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "自分はそんなにやばいやつじゃないはずだ……。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage2-goalFailed");
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "壁に体当たりしたりしてみてもいいかもね。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage2-goalFailed");
            }
            break;
        case 3:
            if (value == "だいく") {
                se[2].play();
                if (flagManager.has("yakisoba")) {
                    requestTalk([
                        new Speech({
                            content: "――そうだ。自分は大工として働いていた。",
                        }),
                        new Speech({
                            content: "一緒に働いていた人はいない？",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "――そうだ。思い出した。<br />仕事仲間とよく昼飯を食べたものだ。からあげ定食とか。",
                        }),
                        new Speech({
                            content: "焼きそばも食べた気がする。",
                        }),
                        new Speech({
                            content: "繋がってきたわね。",
                            speakerName: "謎の声",
                        }),
                    ]).then(() => {
                        flagManager.add("stage3-cleared");
                        stageClear();
                    });
                } else {
                    requestTalk([
                        new Speech({
                            content: "――そうだ。自分は大工として働いていた。",
                        }),
                        new Speech({
                            content: "一緒に働いていた人はいない？",
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "――そうだ。思い出した。<br />仕事仲間とよく昼飯を食べたものだ。からあげ定食とか。",
                        }),
                        new Speech({
                            content: "繋がってきたわね。",
                            speakerName: "謎の声",
                        }),
                    ]).then(() => {
                        flagManager.add("stage3-cleared");
                        stageClear();
                    });
                }
            } else if (["かいたい", "とそう", "とそうこう", "さかん", "ばんきん", "ぼうすい", "ないそう", "でんき", "とびこう"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "割と近い職種だった気がする。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage3-goalFailed");
            } else if (["とびしょく", "どぼく"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: 'とはいえ、<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>通りのはずだが。',
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage3-goalFailed");
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "とはいえ、少ない情報から思い出せることもあるかもしれないわ。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage3-goalFailed");
            }
            break;
        case 4:
            if (["かぞく", "ふぁみりー"].includes(value)) {
                se[2].play();
                requestTalk([
                    new Speech({
                        content: "――そうだ。大切なものは、家族だ。",
                    }),
                    new Speech({
                        content: "朝起きて、ともにご飯を食べて、仕事に行く。",
                    }),
                    new Speech({
                        content: "それが幸せだったはずだ。",
                    }),
                    new Speech({
                        content: "脱出までもうすぐね。",
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    stageClear();
                    flagManager.add("stage4-cleared");
                });
            } else if (["むすめ", "はは", "まま", "おかあさん", "つま", "おくさん", "かない", "よめ", "かみさん", "ちち", "ぱぱ", "おとうさん", "あに", "おにい", "いもうと"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "大切なものは一人には絞れない。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage4-goalFailed");
            } else if (["しんぞく", "けんぞく", "しぞく", "しんるい", "えんじゃ", "いちぞく", "いちもん", "みうち", "しんせき", "えんせき", "けつぞく", "かもん", "かてい"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "大体同じ意味だったと思うが、もっと一般的な言葉があったはずだ。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage4-goalFailed");
            } else if (["どうりょう, ゆうじん, ともだち", "とも", "つれ", "ふれんど"].includes(value)) {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "もっと大切な人達がいたはずだ。",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage4-goalFailed");
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "もし見落としがないなら頑張って思い出すしかないわね。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage4-goalFailed");
            }
            break;
        case 5:
            if (value == "しょうま") {
                se[2].play();
                BGM.pause();
                requestTalk([
                    new Speech({
                        content: "――そうだ。俺は――。",
                    }),
                ]).then(() => {
                    pageManager.backPages(2);
                    pageManager.setPage("clear");
                    requestTalk([
                        new Speech({
                            content: "――聞こえる？　ねえ。聞こえる？",
                            speakerName: "？？？",
                        }),
                        new Speech({
                            content: "ここは……。",
                        }),
                        new Speech({
                            content: "佐々木さんが目を覚ましました！",
                            speakerName: "医者",
                        }),
                        new Speech({
                            content: "正真さん！",
                            speakerName: "妻",
                        }),
                        new Speech({
                            content: "お父さん！　どれだけ<ruby>寝坊助<rt>ねぼすけ</rt></ruby>なの……！",
                            speakerName: "娘",
                        }),
                        new Speech({
                            content: "聞くところによれば、俺は三か月は眠っていたらしい。",
                        }),
                        new Speech({
                            content: "釣りの帰りに急に倒れたところを同僚が救急車を呼んでくれたそうだ。",
                        }),
                        new Speech({
                            content: "医者は快復の見込みが無いと伝えたが、妻と娘はしょっちゅう見舞いに来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "そんな中、数日前からいきなり脳が活発になったそうだ。なにがきっかけだろうか。",
                        }),
                        new Speech({
                            content: "まるで脳を修復していくような驚異的な回復力の<ruby>顕<rt>あらわ</rt></ruby>れから、ここ数日は毎日のように来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "……。",
                        }),
                        new Speech({
                            content: "あれは、夢だったのだろうか。",
                        }),
                        new Speech({
                            content: "それとも――。",
                        }),
                    ]).then(() => {
                        flagManager.remove("answer");
                        flagManager.add("stage5-cleared");
                        pageManager.backPages(1);
                        pageManager.setPage("end");
                    });
                });
            } else if (value == "ひかり") {
                BGM.pause();
                requestTalk([
                    new Speech({
                        content: "――そうだ。思い出した。しかしこれは俺の名前ではない。",
                    }),
                    new Speech({
                        content: "思い出した？　お父さ――。",
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    pageManager.backPages(2);
                    pageManager.setPage("clear");
                    requestTalk([
                        new Speech({
                            content: "――聞こえる？　ねえ、お父さん。聞こえる？",
                            speakerName: "？？？",
                        }),
                        new Speech({
                            content: "ここは……。",
                        }),
                        new Speech({
                            content: "佐々木さんが目を覚ましました！",
                            speakerName: "医者",
                        }),
                        new Speech({
                            content: "あなた、良かった……！",
                            speakerName: "恵子",
                        }),
                        new Speech({
                            content: "お父さん！　返事が遅いわよ、ずっと声を掛けていたんだから……！",
                            speakerName: "光",
                        }),
                        new Speech({
                            content: "娘の光が言うところによれば、俺は三か月は眠っていたらしい。",
                        }),
                        new Speech({
                            content: "釣りの帰りに急に倒れたところを同僚が救急車を呼んでくれたそうだ。",
                        }),
                        new Speech({
                            content: "医者は快復の見込みが無いと伝えたが、恵子と光はしょっちゅう見舞いに来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "そんな中、数日前からいきなり脳が活発になったそうだ。光が声をかけていた時のことらしい。",
                        }),
                        new Speech({
                            content: "まるで脳を修復していくような驚異的な回復力の<ruby>顕<rt>あらわ</rt></ruby>れから、ここ数日は毎日のように来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "……。",
                        }),
                        new Speech({
                            content: "あれは、夢だったのだろうか。",
                        }),
                        new Speech({
                            content: "文字通り光が、俺を導いてくれていた。",
                        }),
                        new Speech({
                            content: "そんな気がする。",
                        }),
                    ]).then(() => {
                        flagManager.remove("answer");
                        flagManager.add("stage5-cleared");
                        pageManager.backPages(1);
                        pageManager.setPage("end");
                    });
                });
            } else if (value == "けいこ") {
                BGM.pause();
                requestTalk([
                    new Speech({
                        content: "――そうだ。思い出した。しかしこれは俺の名前ではない。",
                    }),
                    new Speech({
                        content: "さあ、あなたは脱出よ。最愛の妻のもとへ――。",
                        speakerName: "謎の声",
                    }),
                ]).then(() => {
                    pageManager.backPages(2);
                    pageManager.setPage("clear");
                    requestTalk([
                        new Speech({
                            content: "――聞こえる？　ねえ、お父さん。聞こえる？",
                            speakerName: "？？？",
                        }),
                        new Speech({
                            content: "ここは……。",
                        }),
                        new Speech({
                            content: "佐々木さんが目を覚ましました！",
                            speakerName: "医者",
                        }),
                        new Speech({
                            content: "あなた、良かった……！　奇跡だわ！",
                            speakerName: "恵子",
                        }),
                        new Speech({
                            content: "お父さん！　返事が遅いわよ、ずっと声を掛けていたんだから……！",
                            speakerName: "光",
                        }),
                        new Speech({
                            content: "娘の光と妻の恵子が言うところによれば、俺は三か月は眠っていたらしい。",
                        }),
                        new Speech({
                            content: "釣りの帰りに急に倒れたところを同僚が救急車を呼んでくれたそうだ。",
                        }),
                        new Speech({
                            content: "医者は快復の見込みが無いと伝えたが、恵子と光はしょっちゅう見舞いに来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "そんな中、数日前からいきなり脳が活発になったそうだ。光が声をかけていた時のことらしい。",
                        }),
                        new Speech({
                            content: "まるで脳を修復していくような驚異的な回復力の<ruby>顕<rt>あらわ</rt></ruby>れから、ここ数日は毎日のように来てくれていたようだ。",
                        }),
                        new Speech({
                            content: "……。",
                        }),
                        new Speech({
                            content: "あれは、夢だったのだろうか。",
                        }),
                        new Speech({
                            content: "文字通り光が、俺を導いてくれていた。",
                        }),
                        new Speech({
                            content: "そんな気がする。",
                        }),
                        new Speech({
                            content: "それからというもの、俺はリハビリの毎日を過ごし、数カ月で退院できた。",
                        }),
                        new Speech({
                            content: "恵子は病院食続きだった俺のためにと、好物を用意してくれた。",
                        }),
                        new Speech({
                            content: "しかし、からあげは病み上がりには流石に重かった。",
                        }),
                        new Speech({
                            content: "……。",
                        }),
                        new Speech({
                            content: "実のところなぜ倒れたかは分かっていない。",
                        }),
                        new Speech({
                            content: "医者は、あのままだと一ヵ月もしないうちに死んでいたということしか言わない。",
                        }),
                        new Speech({
                            content: "ただついていなかっただけなのだろうか。",
                        }),
                        new Speech({
                            content: "そういえば、思い出したことがある。",
                        }),
                        new Speech({
                            content: 'それは、俺はからあげより<font style="color:#dd0000;">焼きそば</font>の方が好きだったかもしれない、ということだ。',
                        }),
                    ]).then(() => {
                        flagManager.remove("answer");
                        flagManager.add("stage5-cleared");
                        pageManager.backPages(1);
                        pageManager.setPage("end");
                    });
                });
            } else {
                pageManager.backPages(1);
                gameManager.respawn();
                gameManager.start();
                sleep(20).then(() => {
                    requestTalk([
                        new Speech({
                            content: "最初にいた場所に戻ってしまったようだ。",
                        }),
                        new Speech({
                            content:
                                'うまく思い出せなかったようね。もう一度<font style="color:#00dd00">記憶の<ruby style="color:#00dd00">欠片<rt style="color:#00dd00">かけら</rt></ruby></font>を探しなさい。',
                            speakerName: "謎の声",
                        }),
                        new Speech({
                            content: "何かあるところには行くことができるはずよ。",
                            speakerName: "謎の声",
                        }),
                    ]);
                });
                flagManager.remove("answer");
                flagManager.add("stage5-goalFailed");
            }
            break;
    }
});

//ページ開始処理
function stageStart(stage: Stage) {
    pageManager.setPage("play");
    if (gameManager) {
        gameManager.remove();
    }
    qs("#play").appendChild(stage.g$element);
    gameManager = stage.g$gameManager;
    window.dispatchEvent(new Event("resize"));
    talkPanel.resetTalk();
    const dustAnimation = new DustAnimation(qs(".gamePanel"));
    dustAnimation.addDusts(40);
}

let stageMagnification = 1;

//画面サイズを変更してもステージの見え方が変わらないようにする
window.addEventListener("resize", () => {
    if (gameManager) {
        const rate = qs("body").clientHeight / (700 * stageMagnification);
        gameManager.changeMagnificationRate(1 / rate);
        gameManager.changeMagnificationRateContinuously(1 / rate);
        gameManager.setCamera();
    }
});

//メニューを開いたらゲーム進行を止める
pageManager.addEvent(["setPage-menu"], () => {
    if (gameManager) {
        gameManager.stop();
    }
    talkPanel.stop();
});

qsAddEvent("#resumeButton", "click", () => {
    if (talkPanel.g$hasStarted && !talkPanel.g$hasFinishedTalk) {
        talkPanel.start();
    } else {
        gameManager.start();
    }
});

qsAddEvent("#quitButton", "click", () => {
    pageManager.backPages(-1);
    pageManager.setPage("title");
    talkPanel.resetTalk();
});

qsAddEvent("#retryButton", "click", () => {
    if (qs("#talk").style.display != "none") {
        pageManager.backPages(3);
        talkPanel.resetTalk();
        qs("#play .menuButton").style.display = "flex";
    } else {
        pageManager.backPages(2);
    }
    console.log(stageNumber);
    qs('[data-stage="' + stageNumber + '"]').click();
});

function startDebugMode(stageNumber: number) {
    qs('[data-stage="' + stageNumber + '"]').click();
    stageMagnification = 1;
    window.dispatchEvent(new Event("resize"));
}

qsAddEvent("#end", "click", () => {
    flagManager.add("clear");
    pageManager.backPages(-1);
    pageManager.setPage("title");
    talkPanel.resetTalk();
});

let se: Sound[];
let bgm = -1;

qsAddEvent("button", "click", () => {
    se[0].play();
});

talkPanel.addEvent(["write"], () => {
    if (flagManager.has("invalid")) {
        talkPanel.stop();
        talkPanel.reset();
    } else {
        se[1].play();
    }
});

talkPanel.addEvent(["displayNextSpeech"], () => {
    se[0].play();
});

pageManager.addEvent(["pageChanged-title"], async () => {
    if (bgm != 0) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/彷徨う回顧録.mp3" });
        await BGM.play();
        bgm = 0;
        pageManager.s$valid = true;
    }
});

pageManager.addEvent(["setPage-stageSelect"], async () => {
    if (bgm != 0) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/彷徨う回顧録.mp3" });
        await BGM.play();
        bgm = 0;
        pageManager.s$valid = true;
    }
});

pageManager.addEvent(["pageChanged-dark"], async () => {
    if (bgm != 1) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/魔力に満ちた部屋.mp3" });
        await BGM.play();
        bgm = 1;
        pageManager.s$valid = true;
    }
});

pageManager.addEvent(["pageChanged-play"], async () => {
    if (bgm != 2) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/迷子はどこへ.mp3" });
        await BGM.play();
        if (gameManager) {
            gameManager.setCamera();
        }
        bgm = 2;
        pageManager.s$valid = true;
    }
});

pageManager.addEvent(["pageChanged-clear"], async () => {
    if (bgm != 3) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/日常への出口.mp3", sourceVolume: 0.5 });
        await BGM.play();
        if (gameManager) {
            gameManager.setCamera();
        }
        bgm = 3;
        pageManager.s$valid = true;
    }
});

pageManager.addEvent(["pageBecomeValid"], () => {
    flagManager.remove("invalid");
    if (pageManager.g$currentPageId == "talk") {
        talkPanel.start();
    }
});
pageManager.addEvent(["pageBecomeInvalid"], () => {
    flagManager.add("invalid");
});

async function stageClear() {
    flagManager.remove("answer");
    pageManager.backPages(2);
    if (bgm != 0) {
        pageManager.s$valid = false;
        await BGM.pause();
        await BGM.fetch({ src: "assets/musics/彷徨う回顧録.mp3" });
        await BGM.play();
        bgm = 0;
        pageManager.s$valid = true;
    }
}

qsAddEvent("#bgmVolume", "input", (element) => {
    const value: number = parseInt((element as HTMLInputElement).value);
    BGM.setVolume(value / 10);
});

qsAddEvent("#seVolume", "input", (element) => {
    const value: number = parseInt((element as HTMLInputElement).value);
    Sound.setWholeVolume(value / 10);
});

qsAddEvent('input[type="range"]', "input", () => {
    se[0].play();
});
